import React, { useState, useEffect } from 'react';
import { Button, Modal, Progress, message, Select, DatePicker, Input, Card, Table, Tag, Space, Avatar, Form as AntForm, Popconfirm, Tooltip } from 'antd';
import { Form, InputGroup, Badge } from 'react-bootstrap';
import { PlusOutlined, EditOutlined, DeleteOutlined, EyeOutlined, LoginOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { formatUrlString, encryptId, getuserdata, loginapi, getServiceId } from '../services/apiService';
import axios from 'axios';
import { oneKlicks, sendWhatsApp } from '../SDK/oneclick';
import { OneKlicksFileSDK } from '../SDK/OneKlicksFileSDK';
import ImageShow from '../Uitiles/ImageShow';
import decodeHtml from '../Uitiles/decodeHtml';
import { debugLog } from '../utils/debug';
import Paginationnew from '../Uitiles/Paginationnew';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import AddInvoiceModel from '../Admin/Pages/Components/AddInvoiceModel';

const { TextArea } = Input;

/**
 * IMPORTANT: Call Remarks Feature
 * 
 * The call_remarks functionality requires a 'call_remarks' TEXT column in the 'users' table.
 * Currently, the OneKlicks API doesn't support dynamic column addition, so this column
 * must be added manually by the database administrator.
 * 
 * When the column is missing:
 * - The UI will show a warning message
 * - Call status updates will still work (without remarks)
 * - Users will be prompted to contact support
 * 
 * To enable full functionality, run this SQL:
 * ALTER TABLE users ADD COLUMN call_remarks TEXT NULL;
 */


const Doctors = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [modalData, setModalData] = useState({});
    const [isImporting, setIsImporting] = useState(false);
    const [importProgress, setImportProgress] = useState(0);
    const [currentImportItem, setCurrentImportItem] = useState('');
    const [usertype, setUsertype] = useState('');
    const [loading, setLoading] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [showImportModalimage, setShowImportModalimage] = useState(false);
    const [showImportGoogleId, setShowImportGoogleId] = useState(false);
    const [showPackageModal, setShowPackageModal] = useState(false);
    const [selectedDoctorForPackage, setSelectedDoctorForPackage] = useState(null);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(20);
    const [totalPages, setTotalPages] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [specialities, setSpecialities] = useState([]);
    const [showAddEditModal, setShowAddEditModal] = useState(false);
    const [editingDoctor, setEditingDoctor] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [addEditForm] = AntForm.useForm();

    useEffect(() => {
        getDoctors();
        getSpecialities();
    }, []);

    const getSpecialities = async () => {
        try {
            const tableSchema = '';
            const tableName = 'specialities';
            const conditions = {}; // Removed status filter
            const response = await oneKlicks.read(tableSchema, tableName, conditions, 'name ASC', {}, {}, '');
            if (response && response.data) {
                setSpecialities(response.data);
            }
        } catch (error) {
            console.error('Error fetching specialities:', error);
        }
    };

    useEffect(() => {
        getDoctors();
    }, [searchText, page]);

    const getDoctors = async () => {
        try {
            setLoading(true);
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                user_type: 'doctor'
            };
            const orderBy = 'id DESC';
            const search = {
                ...searchText && {
                    email: searchText,
                    phone: searchText,
                    display_name: searchText,
                    address: searchText,
                    status: searchText,
                    country: searchText,
                    id: searchText
                }
            };

            const pagination = {
                page: page,
                limit: limit
            };
            const margedata = [
                {
                    target_table: "doctor_default_location",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "location"
                },
                {
                    target_table: "user_package",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "user_package",
                    margedata: [
                        {
                            target_table: "packages",
                            target_column: "id",
                            target_value: "package_id",
                            target_label: "package_details"
                        }
                    ]
                },
            ];

            const location = await getuserdata('location');
            const usertype = await getuserdata('user_type');

            console.log("location doctors :", location);

            let range = [];
            if (usertype === 'staff' && location) {
                try {
                    const parsedLocation = typeof location === 'string' ? JSON.parse(location) : location;
                    if (parsedLocation && (parsedLocation.lat || parsedLocation.latitude) && (parsedLocation.lng || parsedLocation.longitude)) {
                        range = {
                            latitude: parsedLocation.lat || parsedLocation.latitude,
                            longitude: parsedLocation.lng || parsedLocation.longitude,
                            radius: 20, // in kilometers
                            target_latitude: "lat",
                            target_longitude: "lng",
                            table_name: "doctor_default_location",       // join table
                            join_column: "user_id",            // foreign key in user_location
                            base_column: "id"                  // primary key in user
                        };
                    }
                } catch (e) {
                    console.error("Error processing location data:", e);
                }
            }

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);

            if (!response || !response.data) {
                throw new Error('Invalid response from server');
            }

            debugLog('getDoctors response :', response.data);
            setData(response.data);
            setTotalPages(response.totalPages);
            setUsertype(usertype);
        } catch (error) {
            console.error('getDoctors response:', error);
            message.error('Failed to fetch doctors. Please try again.');
            setData([]);
        } finally {
            setLoading(false);
        }
    }

    const openImportModal = () => {
        setShowImportModal(true);
    };

    const openImportModalimage = () => {
        setShowImportModalimage(true);
    };

    const openImportGoogleId = () => {
        setShowImportGoogleId(true);
    };

    const closeImportModal = () => {
        setShowImportModal(false);
    };

    const closeImportModalimage = () => {
        setShowImportModalimage(false);
    };

    const closeImportGoogleId = () => {
        setShowImportGoogleId(false);
    };

    const handleImportGoogleId = async () => {
        setIsImporting(true);
        setImportProgress(0);
        let successCount = 0;
        let errorCount = 0;

        try {
            const doctorIds = data;
            const totalItems = data.length;
            let processedItems = 0;

            for (const doctorId of doctorIds) {
                try {
                    setCurrentImportItem(`Processing doctor ID: ${doctorId.display_name}`);

                    // Get individual doctor data
                    const doctorResponse = await axios.post('//css.meddylist.com//wp-json/api/v1/listing/get_doctor', {
                        "user_id": doctorId.id
                    });

                    console.log("doctorResponse", doctorResponse.data[0]);

                    if (!doctorResponse.data || !doctorResponse.data[0]) {
                        throw new Error('Invalid doctor data received');
                    }

                    const doctor = doctorResponse.data[0];

                    // Create doctor in database
                    const tableSchema = '';
                    const tableName = 'users';
                    const doctorModel = {   //address
                        speciality_ids: JSON.stringify(doctor.specialities),
                        address: doctor.address,
                        longitude: doctor.longitude,
                        latitude: doctor.latitude

                    };

                    const conditions = {
                        id: doctorId.id
                    };


                    const createResponse = await oneKlicks.update(tableSchema, tableName, doctorModel, conditions);

                    if (createResponse && createResponse.success) {
                        successCount++;
                        message.success(`Successfully imported: ${doctorId.display_name}`);
                    } else {
                        errorCount++;
                        message.error(`Failed to import: ${doctorId.display_name}`);
                    }

                    processedItems++;
                    const progress = Math.round((processedItems / totalItems) * 100);
                    setImportProgress(progress);

                    // Add a small delay to prevent overwhelming the server
                    await new Promise(resolve => setTimeout(resolve, 500));

                } catch (error) {
                    console.error('Import failed:', error);
                    message.error('Import failed. Please try again.');
                }
            }

            message.success(`Import completed! Successfully imported ${successCount} items. ${errorCount} items failed.`);
            await getDoctors(); // Refresh the list after import

        } catch (error) {
            console.error('Import failed:', error);
            message.error('Import failed. Please try again.');
        } finally {
            setIsImporting(false);
            setCurrentImportItem('');
            setImportProgress(0);
            closeImportGoogleId();
        }
    };

    const handleImport = async () => {
        setIsImporting(true);
        setImportProgress(0);
        let successCount = 0;
        let errorCount = 0;

        try {
            const doctorIds = data;
            const totalItems = data.length;
            let processedItems = 0;

            for (const doctorId of doctorIds) {
                try {
                    setCurrentImportItem(`Processing doctor ID: ${doctorId.display_name}`);

                    // Get individual doctor data
                    const doctorResponse = await axios.post('//css.meddylist.com//wp-json/api/v1/listing/get_doctor', {
                        "user_id": doctorId.id
                    });

                    console.log("doctorResponse", doctorResponse.data[0]);



                    const specialities = doctorResponse.data[0].specialities;

                    console.log("specialities", specialities);

                    for (const speciality in specialities) {
                        console.log("speciality", speciality);
                        for (const serviceId in specialities[speciality]) {
                            console.log("serviceId", serviceId);
                            const serviceData = specialities[speciality][serviceId];
                            for (const service of serviceData) {
                                console.log("service", service);
                                console.log("price", service.price);
                                console.log("description", service.description);
                            }
                            const getServiceIdRes = await getServiceId(serviceId);
                        }
                    }

                    if (!doctorResponse.data || !doctorResponse.data[0]) {
                        throw new Error('Invalid doctor data received');
                    }

                    const doctor = doctorResponse.data[0];

                    // // Upload profile photo if exists
                    let profile_photo = '';
                    if (doctor.image) {
                        const root = 'doctors';
                        const status = 'publish';
                        const uploadimage = await OneKlicksFileSDK.uploadFileFromUrl(root, status, doctor.image);
                        if (uploadimage && uploadimage.fileId) {
                            profile_photo = uploadimage.fileId;
                        }
                    }



                    // Create doctor in database
                    const tableSchema = '';
                    const tableName = 'users';
                    const doctorModel = {
                        address: doctor.address || '',
                        longitude: doctor.longitude || '',
                        latitude: doctor.latitude || '',
                        email: doctor.email || '',
                        first_name: doctor.first_name || '',
                        last_name: doctor.last_name || '',
                        subheading: doctor.sub_heading || '',
                        description: doctor.short_description || '',
                        starting_price: doctor.starting_price || '',
                        contents: doctor.contents || '',
                        phone: doctor.phone || '',
                        profile_photo: profile_photo,
                        experience: doctor.experience || '',
                        qualification: doctor.qualification || '',
                        country: doctor.country || '',
                        speciality_ids: specialities
                    };

                    const conditions = {
                        id: doctorId.id
                    };

                    const createResponse = await oneKlicks.update(tableSchema, tableName, doctorModel, conditions);

                    if (createResponse && createResponse.success) {
                        successCount++;
                        message.success(`Successfully imported: ${doctorId.display_name}`);
                    } else {
                        errorCount++;
                        message.error(`Failed to import: ${doctorId.display_name}`);
                    }

                    processedItems++;
                    const progress = Math.round((processedItems / totalItems) * 100);
                    setImportProgress(progress);

                    // Add a small delay to prevent overwhelming the server
                    await new Promise(resolve => setTimeout(resolve, 500));

                } catch (error) {
                    errorCount++;
                    console.error(`Error processing doctor ID ${doctorId}:`, error);
                    message.error(`Failed to import doctor ID ${doctorId}: ${error.message}`);
                }
            }

            message.success(`Import completed! Successfully imported ${successCount} items. ${errorCount} items failed.`);
            await getDoctors(); // Refresh the list after import

        } catch (error) {
            console.error('Import failed:', error);
            message.error('Import failed. Please try again.');
        } finally {
            setIsImporting(false);
            setCurrentImportItem('');
            setImportProgress(0);
            closeImportModal();
        }
    };

    const handleImportImages = async () => {
        setIsImporting(true);
        setImportProgress(0);
        let successCount = 0;
        let errorCount = 0;

        try {
            const doctorIds = data;
            const totalItems = data.length;
            let processedItems = 0;

            for (const doctorId of doctorIds) {
                try {
                    setCurrentImportItem(`Processing doctor ID: ${doctorId.display_name}`);

                    if (!doctorId.profile_url) {
                        const imageResponse = await OneKlicksFileSDK.getfile(doctorId.profile_photo);

                        console.log("imageResponse", imageResponse.fileUrl);

                        if (imageResponse && imageResponse.fileUrl) {
                            // Remove https://apis.oneklicks.com from the URL
                            const cleanUrl = imageResponse.fileUrl.replace('https://apis.oneklicks.com', '');
                            const fullUrl = imageResponse.fileUrl;

                            const tableSchema = '';
                            const tableName = 'users';
                            const updateData = {
                                profile_url: cleanUrl,
                                profile_photo_url: fullUrl
                            };
                            const condition = {
                                id: doctorId.id
                            };
                            const updateResponse = await oneKlicks.update(tableSchema, tableName, updateData, condition);
                            if (updateResponse && updateResponse.success) {
                                successCount++;
                                message.success(`Successfully imported: ${doctorId.display_name}`);
                            } else {
                                errorCount++;
                                message.error(`Failed to update database for: ${doctorId.display_name}`);
                            }
                        } else {
                            errorCount++;
                            message.error(`No image found for: ${doctorId.display_name} (ID: ${doctorId.profile_photo || 'Missing'})`);
                        }

                        processedItems++;
                        const progress = Math.round((processedItems / totalItems) * 100);
                        setImportProgress(progress);

                        // Add a small delay to prevent overwhelming the server
                        await new Promise(resolve => setTimeout(resolve, 500));
                    }
                } catch (error) {
                    errorCount++;
                    console.error(`Error processing doctor ID ${doctorId.id}:`, error);
                    message.error(`Failed to import doctor ID ${doctorId.id}: ${error.message}`);
                }
            }

            message.success(`Import completed! Successfully imported ${successCount} items. ${errorCount} items failed.`);
            await getDoctors(); // Refresh the list after import

        } catch (error) {
            console.error('Import failed:', error);
            message.error('Import failed. Please try again.');
        } finally {
            setIsImporting(false);
            setCurrentImportItem('');
            setImportProgress(0);
            closeImportModalimage();
        }
    };




    const handleNavigation = (userData) => {
        setTimeout(() => {
            switch (userData.user_type?.toLowerCase()) {
                case "admin":
                    navigate("/admin-dashboard");
                    break;
                case "doctor":
                    navigate(`/doctor/dashboard/${encryptId(userData.id)}`);
                    break;
                case "hospitals":
                    navigate("/hospital/dashboard");
                    break;
                case "regular_users":
                    navigate("/patient/dashboard");
                    break;
                case "patient":
                    navigate("/patient-dashboard");
                    break;
                case "pharmacy":
                    navigate("/pharmacy/dashboard");
                    break;
                case "user":
                    // Stay on home page - user can access dashboard from header dropdown
                    navigate("/");
                    break;
                case "administrator":
                    navigate("/superadmin/dashboard");
                    break;
                case "staff":
                    navigate("/superadmin/dashboard");
                    break;
                case "editor":
                    navigate("/editor/dashboard");
                    break;
                default:
                    // For unknown roles, stay on home page
                    navigate("/");
                    break;
            }
        }, 1500);
    };

    const createEmail = async (display_name) => {
        const cleanName = (display_name || 'user').toLowerCase().replace(/[^a-z0-9]/g, '').substring(0, 10);
        const uniqueId = Math.random().toString(36).substring(2, 7);
        const email = `${cleanName}${uniqueId}@meddylist.com`;
        return email;
    };

    const handleLoginAs = async (record, event) => {
        try {
            // Prevent default anchor behavior
            const persintuser = await getuserdata('full');
            console.log("persintuser", persintuser);

            // save the persintuser to the record in local storage
            localStorage.setItem('presentuser', JSON.stringify(persintuser));
            localStorage.setItem('redirect_url_admin', '/superadmin/doctors');

            const localuser = localStorage.getItem("presentuser");
            console.log("localuser", localuser);

            console.log('Attempting email login...');
            if (record.email == "") {
                const createemail = await createEmail(record.display_name);
                record.email = createemail;
                const tableSchema = '';
                const tableName = 'users';
                const data = {
                    email: createemail
                };
                const condition = {
                    id: record.id
                };
                const updateemail = await oneKlicks.update(tableSchema, tableName, data, condition);
                if (updateemail && updateemail.success) {
                    console.log('Email created successfully');
                } else {
                    console.log('Failed to create email');
                }
            }
            const loginResponse = await loginapi(record.email, record.pass, true);
            console.log('Login response:', loginResponse);

            const user = loginResponse.data[0];

            if (user) {
                if (user.status === "2") {
                    toast.error("Your account has been deleted. Please contact support.");
                    return;
                }

                const userData = {
                    id: user.id,
                    email: user.email,
                    user_type: user.user_type,
                    display_name: user.display_name || user.email
                };

                console.log('User data prepared for login:', userData);
                // Use the login function from AuthContext
                const loginSuccess = await login(userData);
                console.log('Login success status:', loginSuccess);

                if (loginSuccess) {
                    toast.success("Login successful!", { autoClose: 2000 });
                    handleNavigation(userData);
                } else {
                    console.error('Login failed - login function returned false');
                    toast.error("Login failed. Please try again.");
                }
            } else {
                console.error('No user data in response');
                toast.error("Invalid credentials. Please try again.");
            }
        } catch (error) {
            console.error('Error in handleEdit:', error);
            toast.error(`Operation failed: ${error.message || 'Server error'}`);
        }
    };

    const handleDelete = (record, event) => {
        // Prevent default anchor behavior
        if (event) {
            event.preventDefault();
        }
        console.log("handleDelete record", record);
        const confirmDelete = window.confirm(`Are you sure you want to delete "${decodeHtml(record.name)}"?`);

        if (confirmDelete) {
            try {
                const tableSchema = '';
                const tableName = 'users';
                oneKlicks.delete(tableSchema, tableName, { id: record.id })
                    .then(response => {
                        if (response && response.success) {
                            message.success('Doctor deleted successfully');
                            OneKlicksFileSDK.deleteFile(record.url).then(response => {
                                console.log(response);
                                getDoctors();
                            })
                        } else {
                            message.error('Failed to delete doctor');
                        }
                    })
                    .catch(error => {
                        console.error('Error deleting doctor:', error);
                        message.error('Failed to delete doctor');
                    });

            } catch (error) {
                console.error('Error deleting doctor:', error);
                message.error('Failed to delete doctor');
            }
        }
    };

    const handleStatusToggle = async (record) => {
        try {
            const newStatus = record.status == 1 ? 0 : 1;
            const statusText = newStatus == 1 ? 'Active' : 'Inactive';

            const tableSchema = '';
            const tableName = 'users';
            const payload = { status: newStatus };
            const condition = { id: record.id };

            const response = await oneKlicks.update(tableSchema, tableName, payload, condition);

            if (response && response.success) {
                message.success(`Status changed to ${statusText}`);
                await getDoctors(); // Refresh the list
            } else {
                message.error('Failed to update status');
            }
        } catch (error) {
            console.error('Error updating status:', error);
            message.error('Failed to update status');
        }
    };

    const handleAdd = () => {
        setEditingDoctor(null);
        addEditForm.resetFields();
        setShowAddEditModal(true);
    };

    const handleEditProfile = (record) => {
        setEditingDoctor(record);
        // Parse speciality_ids if it's a string
        let specIds = [];
        try {
            if (record.speciality_ids) {
                specIds = typeof record.speciality_ids === 'string' ? JSON.parse(record.speciality_ids) : record.speciality_ids;
            }
        } catch (e) {
            console.error("Error parsing speciality_ids:", e);
        }

        addEditForm.setFieldsValue({
            display_name: record.display_name,
            first_name: record.first_name,
            last_name: record.last_name,
            email: record.email,
            phone: record.phone,
            address: record.address,
            speciality_ids: specIds,
            status: record.status == 1 ? 'active' : 'inactive'
        });
        setShowAddEditModal(true);
    };

    const handleSaveDoctor = async (values) => {
        try {
            setFormLoading(true);
            const tableSchema = '';
            const tableName = 'users';
            
            const payload = {
                ...values,
                status: values.status === 'active' ? 1 : 0,
                speciality_ids: JSON.stringify(values.speciality_ids || []),
                speciality_id: (values.speciality_ids && values.speciality_ids.length > 0) ? values.speciality_ids[0] : null,
                user_type: 'doctor'
            };

            let response;
            if (editingDoctor) {
                // Update
                response = await oneKlicks.update(tableSchema, tableName, payload, { id: editingDoctor.id });
            } else {
                // Create
                // For new doctors, we might need a default password if not provided
                if (!payload.password) {
                    payload.password = 'Meddy@123'; // Default password
                }
                response = await oneKlicks.create(tableSchema, tableName, payload);
            }

            if (response && response.success) {
                message.success(`Doctor ${editingDoctor ? 'updated' : 'added'} successfully`);
                setShowAddEditModal(false);
                getDoctors();
            } else {
                message.error(response.message || `Failed to ${editingDoctor ? 'update' : 'add'} doctor`);
            }
        } catch (error) {
            console.error('Error saving doctor:', error);
            message.error('An error occurred while saving doctor');
        } finally {
            setFormLoading(false);
        }
    };

    const handleModalCancel = () => {
        setShowAddEditModal(false);
        setEditingDoctor(null);
        addEditForm.resetFields();
    };

    const handlePageChange = (page) => {
        setPage(page);
    };

    const [callStatusOptions] = useState([
        { value: 'Reschedule', label: 'Reschedule' },
        { value: 'Not Respond', label: 'Not Respond' },
        { value: 'Wrong Number', label: 'Wrong Number' },
        { value: 'Not Interested', label: 'Not Interested' },
        { value: 'Not Answered', label: 'Not Answered' },
    ]);
    const [callStatusValue, setCallStatusValue] = useState(null);
    const [rescheduleDate, setRescheduleDate] = useState('');
    const [callStatusModelshow, setCallStatusModelshow] = useState(false);
    const [selectedDoctorForCallStatus, setSelectedDoctorForCallStatus] = useState(null);
    const [callStatusDate, setCallStatusDate] = useState('');
    const [callRemarks, setCallRemarks] = useState('');

    const openCallStatusModal = async (doctor) => {
        try {
            // Fetch fresh data for this specific doctor to get latest call status
            const tableSchema = '';
            const tableName = 'users';
            const conditions = { id: doctor.id };
            const orderBy = '';
            const search = {};
            const pagination = { page: 1, limit: 1 };
            const margedata = [];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response && response.data && response.data.length > 0) {
                const freshDoctorData = response.data[0];
                setSelectedDoctorForCallStatus(freshDoctorData);

                // Initialize selection from fresh data
                if (freshDoctorData && typeof freshDoctorData.call_status === 'string') {
                    if (freshDoctorData.call_status.startsWith('Reschedule')) {
                        setCallStatusValue('Reschedule');
                    } else if (freshDoctorData.call_status === 'Not Respond') {
                        setCallStatusValue('Not Respond');
                    } else if (freshDoctorData.call_status === 'Wrong Number') {
                        setCallStatusValue('Wrong Number');
                    } else if (freshDoctorData.call_status === 'Not Interested') {
                        setCallStatusValue('Not Interested');
                    } else if (freshDoctorData.call_status === 'Not Answered') {
                        setCallStatusValue('Not Answered');
                    } else {
                        setCallStatusValue(null);
                    }
                } else {
                    setCallStatusValue(null);
                }

                setRescheduleDate(freshDoctorData.call_status_date);
                setCallStatusDate(freshDoctorData.call_status_date);
                setCallRemarks(freshDoctorData.call_remarks || '');
            } else {
                // Fallback to original data if fetch fails
                setSelectedDoctorForCallStatus(doctor);
                if (doctor && typeof doctor.call_status === 'string') {
                    if (doctor.call_status.startsWith('Reschedule')) {
                        setCallStatusValue('Reschedule');
                    } else if (doctor.call_status === 'Not Respond') {
                        setCallStatusValue('Not Respond');
                    } else if (doctor.call_status === 'Wrong Number') {
                        setCallStatusValue('Wrong Number');
                    } else if (doctor.call_status === 'Not Interested') {
                        setCallStatusValue('Not Interested');
                    } else if (doctor.call_status === 'Not Answered') {
                        setCallStatusValue('Not Answered');
                    } else {
                        setCallStatusValue(null);
                    }
                } else {
                    setCallStatusValue(null);
                }
                setRescheduleDate(doctor.call_status_date);
                setCallStatusDate(doctor.call_status_date);
                setCallRemarks(doctor.call_remarks || '');
            }
        } catch (error) {
            console.error('Error fetching fresh doctor data:', error);
            // Fallback to original data if fetch fails
            setSelectedDoctorForCallStatus(doctor);
            if (doctor && typeof doctor.call_status === 'string') {
                if (doctor.call_status.startsWith('Reschedule')) {
                    setCallStatusValue('Reschedule');
                } else if (doctor.call_status === 'Not Respond') {
                    setCallStatusValue('Not Respond');
                } else if (doctor.call_status === 'Wrong Number') {
                    setCallStatusValue('Wrong Number');
                } else if (doctor.call_status === 'Not Interested') {
                    setCallStatusValue('Not Interested');
                } else if (doctor.call_status === 'Not Answered') {
                    setCallStatusValue('Not Answered');
                } else {
                    setCallStatusValue(null);
                }
            } else {
                setCallStatusValue(null);
            }
            setRescheduleDate(doctor.call_status_date);
            setCallStatusDate(doctor.call_status_date);
            setCallRemarks(doctor.call_remarks || '');
        }

        setCallStatusModelshow(true);
    };

    const renderCallHistory = () => {
        try {
            const callHistory = selectedDoctorForCallStatus?.call_status_date ?
                (typeof selectedDoctorForCallStatus.call_status_date === 'string' ?
                    JSON.parse(selectedDoctorForCallStatus.call_status_date) :
                    selectedDoctorForCallStatus.call_status_date) : null;

            if (callHistory && callHistory.date) {
                return (
                    <div>
                        <p><strong>Current Status:</strong> {selectedDoctorForCallStatus.call_status || 'Not Set'}</p>
                        {selectedDoctorForCallStatus.call_remarks && (
                            <div style={{
                                padding: '10px',
                                margin: '10px 0',
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffeaa7',
                                borderRadius: '4px'
                            }}>
                                <p style={{ margin: '0', fontWeight: 'bold', color: '#856404' }}>📝 Current Remarks:</p>
                                <p style={{ margin: '5px 0 0 0', color: '#856404' }}>{selectedDoctorForCallStatus.call_remarks}</p>
                            </div>
                        )}

                        {/* Show note if remarks field is not available in database */}
                        {!selectedDoctorForCallStatus.call_remarks && callRemarks && callRemarks.trim() !== '' && (
                            <div style={{
                                padding: '10px',
                                margin: '10px 0',
                                backgroundColor: '#f8d7da',
                                border: '1px solid #f5c6cb',
                                borderRadius: '4px'
                            }}>
                                <p style={{ margin: '0', fontWeight: 'bold', color: '#721c24' }}>⚠️ Remarks Not Saved:</p>
                                <p style={{ margin: '5px 0 0 0', color: '#721c24' }}>"{callRemarks}"</p>
                                <p style={{ margin: '5px 0 0 0', fontSize: '12px', color: '#721c24' }}>
                                    <em>Database field 'call_remarks' not available. Contact administrator to add this field.</em>
                                </p>
                            </div>
                        )}
                        {callHistory.date.time && Array.isArray(callHistory.date.time) && callHistory.date.time.length > 0 ? (
                            <div>
                                <p><strong>Reschedule History:</strong></p>
                                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                    {callHistory.date.time.map((entry, index) => (
                                        <div key={index} style={{
                                            padding: '8px',
                                            margin: '5px 0',
                                            backgroundColor: 'white',
                                            border: '1px solid #e8e8e8',
                                            borderRadius: '4px'
                                        }}>
                                            <span style={{ fontWeight: 'bold' }}>📅 {new Date(entry.date).toLocaleString()}</span>
                                            <br />
                                            <span style={{ fontSize: '12px', color: '#666' }}>User ID: {entry.user_id}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            <p style={{ color: '#666', fontStyle: 'italic' }}>No reschedule history available</p>
                        )}
                    </div>
                );
            } else {
                return <p style={{ color: '#666', fontStyle: 'italic' }}>No call history available</p>;
            }
        } catch (error) {
            return <p style={{ color: '#666', fontStyle: 'italic' }}>No call history available</p>;
        }
    };

    // Share Profile functionality
    const [showShareModal, setShowShareModal] = useState(false);
    const [selectedDoctorForShare, setSelectedDoctorForShare] = useState(null);
    const [shareSending, setShareSending] = useState(false);

    const handleShareProfile = (doctor) => {
        console.log("doctor selected for share :", doctor);
        setSelectedDoctorForShare(doctor);
        setShowShareModal(true);
    };

    const closeShareModal = () => {
        setShowShareModal(false);
        setSelectedDoctorForShare(null);
    };

    // Package Modal functionality
    const openPackageModal = async (doctor) => {
        console.log("doctor selected for package:", doctor);
        setSelectedDoctorForPackage(doctor);
        setShowPackageModal(true);
    };

    const closePackageModal = () => {
        setShowPackageModal(false);
        setSelectedDoctorForPackage(null);
    };



    const generateProfileLink = (doctor) => {
        const url = `/doctor/${formatUrlString(doctor.display_name)}/${encryptId(doctor.id)}`
        // Generate a profile link - you can customize this based on your routing structure
        const baseUrl = window.location.origin;
        return `${baseUrl}${url}`;
    };

    const handleSendToDoctor = async () => {
        if (!selectedDoctorForShare) return;
        setShareSending(true);
        try {
            const doctor = selectedDoctorForShare;
            const link = generateProfileLink(doctor);

            // Always send WhatsApp message when Send button is clicked
            if (doctor.phone) {
                const whatsappMessage = `🏥 *Doctor Profile*

👨‍⚕️ *${doctor.display_name}*
${doctor.speciality_id ? `🏥 ${doctor.speciality_id}` : ''}
${doctor.country ? `🌍 ${doctor.country}` : ''}
${doctor.address ? `📍 ${doctor.address}` : ''}

🔗 *Profile Link:* ${link}

Book your appointment now! 📞`;

                try {
                    const whatsappResponse = await sendWhatsApp(doctor.phone, whatsappMessage);
                    if (whatsappResponse && whatsappResponse.success) {
                        if (whatsappResponse.data && whatsappResponse.data.status === 'sent') {
                            message.success('WhatsApp message sent directly!');
                        } else {
                            message.success('WhatsApp message sent successfully!');
                        }
                    } else {
                        message.error('Failed to send WhatsApp message. Please try again.');
                    }
                } catch (whatsappError) {
                    console.error('WhatsApp error:', whatsappError);
                    message.error('Failed to send WhatsApp message. Please try again.');
                }
            } else {
                message.error('Doctor phone number not available for WhatsApp sharing.');
            }

            // Log to DB
            try {
                const tableSchema = '';
                const tableName = 'doctor_share_requests';
                const model = {
                    doctor_id: doctor.id,
                    email: doctor.email || '',
                    share_type: 'whatsapp',
                    payload: JSON.stringify({
                        type: 'whatsapp',
                        doctor_id: doctor.id,
                        link
                    }),
                    created_at: new Date().toISOString()
                };
                if (oneKlicks.create) {
                    await oneKlicks.create(tableSchema, tableName, model);
                }
            } catch (e) {
                // ignore if table/service not available
            }

            setShowShareModal(false);
        } catch (e) {
            message.error('Failed to send WhatsApp message.');
        } finally {
            setShareSending(false);
        }
    };

    // Function to add call_remarks column to database
    // NOTE: This function currently returns false because the addColumn endpoint
    // doesn't exist in the current OneKlicks API. The database administrator
    // needs to manually add the 'call_remarks' TEXT column to the 'users' table.
    const addCallRemarksColumn = async () => {
        try {
            // Since the addColumn endpoint doesn't exist in the current API,
            // we'll return false and let the calling function handle it gracefully
            console.log('Adding call_remarks column to database...');
            console.warn('addColumn endpoint not available in current API. Please contact administrator to add call_remarks column manually.');

            // Show user-friendly message
            message.warning('Call remarks feature requires database column to be added by administrator. Please contact support.');
            return false;
        } catch (error) {
            console.error('Error adding column:', error);
            message.error('Failed to add call remarks column: ' + error.message);
            return false;
        }
    };

    const handleSaveCallStatus = async () => {
        let call_status_date = '';
        if (!selectedDoctorForCallStatus) {
            setCallStatusModelshow(false);
            return;
        }
        try {
            let valueToSave = callStatusValue || '';
            if (valueToSave === 'Reschedule') {
                if (!rescheduleDate) {
                    message.warning('Please pick a reschedule date and time');
                    return;
                }
                valueToSave = 'Reschedule';

                const userId = await getuserdata("id");

                // ✅ Fetch existing call_status_date if present
                let existingData = selectedDoctorForCallStatus.call_status_date;
                let parsedData = null;
                if (existingData) {
                    try {
                        parsedData = JSON.parse(existingData);
                    } catch (e) {
                        parsedData = null;
                    }
                }

                if (parsedData && parsedData.date) {
                    // ✅ Append new reschedule entry inside "time" array
                    if (!Array.isArray(parsedData.date.time)) {
                        // convert old "time" string to array
                        parsedData.date.time = parsedData.date.time
                            ? [{ date: parsedData.date.time, user_id: parsedData.date.user_id }]
                            : [];
                    }

                    parsedData.date.time.push({
                        date: callStatusDate,  // new reschedule datetime
                        user_id: userId
                    });

                    call_status_date = parsedData;
                } else {
                    // ✅ First time create fresh structure
                    call_status_date = {
                        date: {
                            date: rescheduleDate,
                            time: [
                                {
                                    date: callStatusDate,
                                    user_id: userId
                                }
                            ],
                            user_id: userId
                        }
                    };
                }

                call_status_date = JSON.stringify(call_status_date);
            }

            const tableSchema = '';
            const tableName = 'users';

            // Create payload with only non-empty values to avoid database issues
            const payload = {
                call_status: valueToSave,
                call_status_date: call_status_date
            };

            // Only add remarks if it's not empty
            if (callRemarks && callRemarks.trim() !== '') {
                payload.call_remarks = callRemarks.trim();
            }

            console.log('Updating call status with payload:', payload);

            const condition = { id: selectedDoctorForCallStatus.id };

            // Try to update with remarks first
            let updateResponse;
            try {
                updateResponse = await oneKlicks.update(tableSchema, tableName, payload, condition);
            } catch (error) {
                console.log('Failed to update with remarks, trying to add column...', error);

                // Try to add the call_remarks column if it doesn't exist
                if (error.message.includes('Unknown column \'call_remarks\'')) {
                    const columnAdded = await addCallRemarksColumn();

                    // Since addColumn endpoint doesn't exist, we'll always fallback to updating without remarks
                    const payloadWithoutRemarks = {
                        call_status: valueToSave,
                        call_status_date: call_status_date
                    };
                    updateResponse = await oneKlicks.update(tableSchema, tableName, payloadWithoutRemarks, condition);
                    message.warning('Call status updated successfully! Remarks feature requires database column to be added by administrator.');
                } else {
                    // For other errors, just fallback to updating without remarks
                    const payloadWithoutRemarks = {
                        call_status: valueToSave,
                        call_status_date: call_status_date
                    };
                    updateResponse = await oneKlicks.update(tableSchema, tableName, payloadWithoutRemarks, condition);
                    message.warning('Call status updated, but remarks could not be saved.');
                }
            }

            if (updateResponse && updateResponse.success) {
                message.success('Call status updated');
                setCallStatusModelshow(false);
                setSelectedDoctorForCallStatus(null);
                await getDoctors();
            } else {
                message.error('Failed to update call status');
            }
        } catch (error) {
            console.error('Call status update error:', error);
            if (error.message.includes('call_remarks')) {
                message.error('Failed to update call status: Remarks field may not exist in database. Please contact administrator.');
            } else {
                message.error('Failed to update call status: ' + error.message);
            }
        }
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 70,
            fixed: 'left',
            sorter: (a, b) => a.id - b.id,
        },
        {
            title: 'Doctor Info',
            key: 'info',
            width: 250,
            render: (text, record) => (
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{ 
                        width: '45px', 
                        height: '45px', 
                        borderRadius: '50%', 
                        overflow: 'hidden',
                        border: '1px solid #e8e8e8',
                        flexShrink: 0
                    }}>
                        <ImageShow 
                            image={record.profile_photo !== "null" ? record.profile_photo : ""} 
                            url={(record.profile_url !== "null" && record.profile_url) ? record.profile_url : (record.profile_photo_url !== "null" ? record.profile_photo_url : "")}
                            type="doctor"
                            width={45}
                            height={45}
                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                        <span style={{ 
                            fontWeight: 600, 
                            color: '#2c3e50', 
                            fontSize: '14px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                            {record.display_name}
                        </span>
                        <span style={{ 
                            fontSize: '12px', 
                            color: '#95a5a6',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                            {record.email}
                        </span>
                    </div>
                </div>
            ),
        },
        {
            title: 'Speciality',
            key: 'speciality',
            width: 180,
            render: (text, record) => {
                let ids = [];
                try {
                    const rawIds = record.speciality_ids || record.speciality_id || [];
                    ids = typeof rawIds === 'string' ? JSON.parse(rawIds) : (Array.isArray(rawIds) ? rawIds : [rawIds].filter(Boolean));
                } catch (e) { ids = []; }
                
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {ids.length > 0 ? ids.map(id => {
                            const spec = specialities.find(s => s.id == id);
                            return spec ? (
                                <Tag color="blue" key={id} style={{ borderRadius: '4px', margin: 0, fontSize: '11px' }}>
                                    {spec.name}
                                </Tag>
                            ) : null;
                        }) : <span style={{ color: '#bdc3c7', fontSize: '11px', fontStyle: 'italic' }}>Pending Assignment</span>}
                    </div>
                );
            }
        },
        {
            title: 'Communication',
            key: 'call_status',
            width: 220,
            render: (text, record) => (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <Button 
                        size="small" 
                        onClick={() => openCallStatusModal(record)}
                        style={{ 
                            width: '100%', 
                            borderRadius: '4px', 
                            fontSize: '12px',
                            backgroundColor: '#f9f9f9',
                            color: '#2c3e50',
                            fontWeight: 500
                        }}
                    >
                        {record.call_status || "Set Call Status"}
                    </Button>
                    <Button 
                        size="small" 
                        type="link"
                        onClick={() => handleShareProfile(record)}
                        style={{ 
                            padding: 0, 
                            fontSize: '11px', 
                            height: 'auto',
                            color: '#3498db'
                        }}
                    >
                        Share Profile Info
                    </Button>
                </div>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            render: (status, record) => (
                <Tag 
                    color={status == 1 ? 'success' : 'error'} 
                    style={{ cursor: 'pointer', borderRadius: '12px', padding: '0 12px' }}
                    onClick={() => handleStatusToggle(record)}
                >
                    {status == 1 ? 'Active' : 'Inactive'}
                </Tag>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            width: 320,
            fixed: 'right',
            render: (text, record) => (
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'nowrap' }}>
                    <Tooltip title="View full profile">
                        <Button 
                            icon={<EyeOutlined />} 
                            size="small" 
                            type="primary"
                            ghost
                            onClick={() => navigate(`/superadmin/doctor-profile/${record.id}`)}
                            style={{ borderRadius: '4px', fontSize: '12px', display: 'flex', alignItems: 'center' }}
                        >
                            View
                        </Button>
                    </Tooltip>
                    <Tooltip title="Edit profile details">
                        <Button 
                            icon={<EditOutlined />} 
                            size="small" 
                            style={{ 
                                borderRadius: '4px', 
                                fontSize: '12px', 
                                color: '#27ae60', 
                                borderColor: '#27ae60',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                            onClick={() => handleEditProfile(record)}
                        >
                            Edit
                        </Button>
                    </Tooltip>
                    <Tooltip title="Switch to this doctor's account">
                        <Button 
                            icon={<LoginOutlined />} 
                            size="small" 
                            style={{ 
                                borderRadius: '4px', 
                                fontSize: '12px', 
                                color: '#e67e22', 
                                borderColor: '#e67e22',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                            onClick={(e) => handleLoginAs(record, e)}
                        >
                            Login
                        </Button>
                    </Tooltip>
                    <Popconfirm
                        title="Delete Doctor"
                        description="Are you sure you want to permanently remove this doctor?"
                        onConfirm={() => handleDelete(record)}
                        okText="Delete"
                        cancelText="Cancel"
                        okButtonProps={{ danger: true }}
                    >
                        <Button 
                            icon={<DeleteOutlined />} 
                            size="small" 
                            danger
                            style={{ borderRadius: '4px', fontSize: '12px', display: 'flex', alignItems: 'center' }}
                        >
                            Delete
                        </Button>
                    </Popconfirm>
                </div>
            ),
        },
    ];

    return (
        <div className="container-fluid py-4" style={{ backgroundColor: '#f0f2f5', minHeight: '100vh' }}>
            <Card 
                bordered={false} 
                className="shadow-sm mb-4"
                style={{ borderRadius: '12px' }}
            >
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div>
                        <h4 style={{ margin: 0, fontWeight: 700, color: '#2c3e50', letterSpacing: '-0.5px' }}>
                            <UserOutlined style={{ marginRight: '12px', color: '#3498db' }} />
                            Doctors Management
                        </h4>
                        <p style={{ color: '#7f8c8d', margin: '4px 0 0 0', fontSize: '13px' }}>
                            Seamlessly manage and monitor your medical network
                        </p>
                    </div>
                    <Space size="middle" wrap>
                        <Input.Search
                            placeholder="Search doctors..."
                            allowClear
                            onSearch={setSearchText}
                            style={{ width: 300, height: '40px', borderRadius: '6px' }}
                            size="large"
                            className="premium-search"
                        />
                        <Button 
                            type="primary" 
                            size="large"
                            icon={<PlusOutlined />} 
                            onClick={handleAdd}
                            style={{ borderRadius: '6px', height: '40px', fontWeight: 600 }}
                        >
                            Add New Doctor
                        </Button>
                        {usertype === 'administrator' && (
                            <Space size="small">
                                <Button 
                                    size="large"
                                    icon={<PlusOutlined />} 
                                    onClick={openImportModal}
                                    style={{ borderRadius: '6px', height: '40px' }}
                                >
                                    Import
                                </Button>
                                <Button 
                                    size="large"
                                    icon={<PlusOutlined />} 
                                    onClick={openImportModalimage}
                                    style={{ borderRadius: '6px', height: '40px' }}
                                >
                                    Images
                                </Button>
                                <Button 
                                    size="large"
                                    icon={<PlusOutlined />} 
                                    onClick={openImportGoogleId}
                                    style={{ borderRadius: '6px', height: '40px' }}
                                >
                                    Google
                                </Button>
                            </Space>
                        )}
                    </Space>
                </div>
            </Card>

            <Card 
                bordered={false} 
                className="shadow-sm" 
                style={{ borderRadius: '12px' }}
                bodyStyle={{ padding: '0' }}
            >
                <Table 
                    columns={columns} 
                    dataSource={data} 
                    rowKey="id" 
                    loading={loading}
                    scroll={{ x: 1100 }}
                    pagination={{
                        current: page,
                        pageSize: limit,
                        total: totalPages * limit,
                        onChange: handlePageChange,
                        showSizeChanger: false,
                        position: ['bottomCenter'],
                    }}
                    className="premium-table"
                />
            </Card>

            {/* Add/Edit Doctor Modal */}
            <Modal
                title={editingDoctor ? "Edit Doctor Profile" : "Add New Doctor"}
                open={showAddEditModal}
                onCancel={handleModalCancel}
                footer={null}
                width={800}
                centered
                destroyOnClose
            >
                <AntForm
                    form={addEditForm}
                    layout="vertical"
                    onFinish={handleSaveDoctor}
                    initialValues={{ status: 'active' }}
                >
                    <div className="row">
                        <div className="col-md-6">
                            <AntForm.Item
                                name="first_name"
                                label="First Name"
                                rules={[{ required: true, message: 'Please enter first name' }]}
                            >
                                <Input placeholder="First Name" />
                            </AntForm.Item>
                        </div>
                        <div className="col-md-6">
                            <AntForm.Item
                                name="last_name"
                                label="Last Name"
                                rules={[{ required: true, message: 'Please enter last name' }]}
                            >
                                <Input placeholder="Last Name" />
                            </AntForm.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <AntForm.Item
                                name="display_name"
                                label="Display Name"
                                rules={[{ required: true, message: 'Please enter display name' }]}
                            >
                                <Input placeholder="Display Name" />
                            </AntForm.Item>
                        </div>
                        <div className="col-md-6">
                            <AntForm.Item
                                name="email"
                                label="Email Address"
                                rules={[
                                    { required: true, message: 'Please enter email' },
                                    { type: 'email', message: 'Please enter a valid email' }
                                ]}
                            >
                                <Input placeholder="Email Address" />
                            </AntForm.Item>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <AntForm.Item
                                name="phone"
                                label="Phone Number"
                                rules={[{ required: true, message: 'Please enter phone number' }]}
                            >
                                <Input placeholder="Phone Number" />
                            </AntForm.Item>
                        </div>
                        <div className="col-md-6">
                            <AntForm.Item
                                name="speciality_ids"
                                label="Specialities"
                            >
                                <Select
                                    mode="multiple"
                                    placeholder="Select specialities"
                                    style={{ width: '100%' }}
                                    allowClear
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {specialities.map(spec => (
                                        <Select.Option key={spec.id} value={spec.id}>
                                            {spec.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </AntForm.Item>
                        </div>
                    </div>

                    {!editingDoctor && (
                        <AntForm.Item
                            name="password"
                            label="Password"
                            rules={[{ required: true, message: 'Please enter password' }]}
                        >
                            <Input.Password placeholder="Password" />
                        </AntForm.Item>
                    )}

                    <AntForm.Item
                        name="address"
                        label="Address"
                    >
                        <TextArea rows={3} placeholder="Full Address" />
                    </AntForm.Item>

                    <div className="row">
                        <div className="col-md-6">
                            <AntForm.Item
                                name="status"
                                label="Account Status"
                            >
                                <Select>
                                    <Select.Option value="active">Active</Select.Option>
                                    <Select.Option value="inactive">Inactive</Select.Option>
                                </Select>
                            </AntForm.Item>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button onClick={handleModalCancel}>Cancel</Button>
                        <Button type="primary" htmlType="submit" loading={formLoading}>
                            {editingDoctor ? 'Save Changes' : 'Create Doctor'}
                        </Button>
                    </div>
                </AntForm>
            </Modal>

                <Modal
                    title="Call Status"
                    open={callStatusModelshow}
                    onCancel={() => setCallStatusModelshow(false)}
                    onOk={handleSaveCallStatus}
                    width={600}
                >
                    {/* Previous Call Status History */}
                    <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                        <h5 style={{ marginBottom: '10px', color: '#1890ff' }}>📞 Call History</h5>
                        {renderCallHistory()}
                    </div>

                    <hr style={{ margin: '20px 0' }} />

                    {/* New Call Status Selection */}
                    <div>
                        <h5 style={{ marginBottom: '15px' }}>🔄 Update Call Status</h5>
                        <Select
                            options={callStatusOptions}
                            value={callStatusValue}
                            onChange={(value) => setCallStatusValue(value)}
                            style={{ width: '100%' }}
                            allowClear
                            placeholder="Select call status"
                        />
                        {callStatusValue === 'Reschedule' && (
                            <>
                                <p style={{ marginTop: 16 }}>Reschedule date</p>
                                <DatePicker
                                    showTime
                                    onChange={(date, dateString) => setRescheduleDate(dateString)}
                                    style={{ width: '100%' }}
                                />
                            </>
                        )}

                        {/* Remarks Field */}
                        <div style={{ marginTop: '16px' }}>
                            <p style={{ marginBottom: '8px' }}>📝 Call Remarks</p>
                            <TextArea
                                placeholder="Enter call remarks, notes, or any additional information..."
                                value={callRemarks}
                                onChange={(e) => setCallRemarks(e.target.value)}
                                rows={4}
                                style={{ width: '100%' }}
                                maxLength={500}
                                showCount
                            />
                        </div>
                    </div>
                </Modal>


                {/* Address Modal */}
                <Modal
                    title="Full Address"
                    open={modalData.showAddressModal}
                    onCancel={() => setModalData({ ...modalData, showAddressModal: false })}
                    footer={[
                        <Button key="close" onClick={() => setModalData({ ...modalData, showAddressModal: false })}>
                            Close
                        </Button>
                    ]}
                >
                    <div>
                        <h4>{modalData.display_name}</h4>
                        <p><strong>Address:</strong></p>
                        <p style={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            backgroundColor: '#f5f5f5',
                            padding: '15px',
                            borderRadius: '5px',
                            border: '1px solid #d9d9d9'
                        }}>
                            {modalData.address || 'No address available'}
                        </p>
                    </div>
                </Modal>

                {/* Share Profile Modal */}
                <Modal
                    title="Share Doctor Profile"
                    open={showShareModal}
                    onCancel={closeShareModal}
                    footer={[
                        <Button key="close" onClick={closeShareModal} disabled={shareSending}>
                            Close
                        </Button>,
                        <Button
                            key="send"
                            type="primary"
                            onClick={handleSendToDoctor}
                            loading={shareSending}
                            disabled={shareSending || !selectedDoctorForShare?.phone}
                        >
                            Send WhatsApp
                        </Button>
                    ]}
                    width={500}
                >
                    {selectedDoctorForShare && (
                        <div>
                            <div style={{ textAlign: 'center', marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <ImageShow url={selectedDoctorForShare.profile_photo_url !== "null" ? selectedDoctorForShare.profile_photo_url : ""} height={80} width={80} style={{ borderRadius: '50%', border: '3px solid #1890ff' }} />
                                <h4 style={{ marginTop: '10px', color: '#1890ff' }}>
                                    {selectedDoctorForShare.display_name}
                                </h4>
                                <p style={{ color: '#666', margin: '5px 0' }}>
                                    {selectedDoctorForShare.speciality_id || 'Specialist'}
                                </p>
                            </div>

                            <div style={{ marginBottom: '20px' }}>
                                <h5>📋 Profile Information</h5>
                                <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px' }}>
                                    <p><strong>Name:</strong> {selectedDoctorForShare.display_name}</p>
                                    <p><strong>Email:</strong> {selectedDoctorForShare.email}</p>
                                    <p><strong>Phone:</strong> {selectedDoctorForShare.phone || 'Not available'}</p>
                                    <p><strong>Country:</strong> {selectedDoctorForShare.location?.length > 0 ? selectedDoctorForShare.location[0].country : selectedDoctorForShare.country}</p>
                                    {selectedDoctorForShare.location && selectedDoctorForShare.location.length > 0 && (
                                        <p><strong>Address:</strong> {selectedDoctorForShare.location?.length > 0 ? selectedDoctorForShare.location[0].address : selectedDoctorForShare.address}</p>
                                    )}
                                    {!selectedDoctorForShare.phone && (
                                        <p style={{ color: '#ff4d4f', fontWeight: 'bold' }}>
                                            ⚠️ WhatsApp sharing requires a phone number
                                        </p>
                                    )}
                                </div>
                            </div>
                            {/* WhatsApp Preview */}
                            <div>
                                <h5>WhatsApp Message Preview</h5>
                                <div style={{ background: '#fafafa', border: '1px solid #eee', borderRadius: 6, padding: 12, fontSize: 12 }}>
                                    <div style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                        {`🏥 *Doctor Profile*

👨‍⚕️ *${selectedDoctorForShare.display_name}*
${selectedDoctorForShare.speciality_id ? `🏥 ${selectedDoctorForShare.speciality_id}` : ''}
${selectedDoctorForShare.location?.length > 0 ? `🌍 ${selectedDoctorForShare.location[0].country}` : selectedDoctorForShare.country ? `🌍 ${selectedDoctorForShare.country}` : ''}
${selectedDoctorForShare.location?.length > 0 ? `📍 ${selectedDoctorForShare.location[0].address}` : selectedDoctorForShare.address ? `📍 ${selectedDoctorForShare.address}` : ''}

🔗 *Profile Link:* ${generateProfileLink(selectedDoctorForShare)}

Book your appointment now! 📞`}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal>

                {/* Package Modal */}
                <AddInvoiceModel showAdd={showPackageModal} setShowAdd={setShowPackageModal} data={""} mode="add" getdata={getDoctors} addbydocter={selectedDoctorForPackage} />

                {/* Import Modals */}
                <Modal
                    title="Import Doctors"
                    open={showImportModal}
                    onCancel={closeImportModal}
                    footer={[
                        <Button key="cancel" onClick={closeImportModal} disabled={isImporting}>
                            Cancel
                        </Button>,
                        <Button key="import" type="primary" onClick={handleImport} loading={isImporting}>
                            Start Import
                        </Button>
                    ]}
                >
                    <p>This will import/update doctor details from the WordPress API.</p>
                    {isImporting && (
                        <div style={{ marginTop: '20px' }}>
                            <p>{currentImportItem}</p>
                            <Progress percent={importProgress} status="active" />
                        </div>
                    )}
                </Modal>

                <Modal
                    title="Import Images"
                    open={showImportModalimage}
                    onCancel={closeImportModalimage}
                    footer={[
                        <Button key="cancel" onClick={closeImportModalimage} disabled={isImporting}>
                            Cancel
                        </Button>,
                        <Button key="import" type="primary" onClick={handleImportImages} loading={isImporting}>
                            Start Fetching Images
                        </Button>
                    ]}
                >
                    <p>This will fetch and fix image URLs for doctors who have missing profile URLs.</p>
                    {isImporting && (
                        <div style={{ marginTop: '20px' }}>
                            <p>{currentImportItem}</p>
                            <Progress percent={importProgress} status="active" />
                        </div>
                    )}
                </Modal>

                <Modal
                    title="Import Google Info"
                    open={showImportGoogleId}
                    onCancel={closeImportGoogleId}
                    footer={[
                        <Button key="cancel" onClick={closeImportGoogleId} disabled={isImporting}>
                            Cancel
                        </Button>,
                        <Button key="import" type="primary" onClick={handleImportGoogleId} loading={isImporting}>
                            Start Import
                        </Button>
                    ]}
                >
                    <p>This will import additional Google/Location info for the doctors.</p>
                    {isImporting && (
                        <div style={{ marginTop: '20px' }}>
                            <p>{currentImportItem}</p>
                            <Progress percent={importProgress} status="active" />
                        </div>
                    )}
                </Modal>

            </div>
    );
};

export default Doctors; 
